import { ValidationError } from '@nextinq.public/usable-form/lib/types';

export function errorFromMessage(source: string, message: string): ValidationError {
  return {
    message,
    code: message,
    source,
    severity: 'error'
  };
}
